
export async function massupload( data ) {

  let url = '/api/users/massupload'
  return await $axios.post( url, data ).then( response => {
    return response.data
  }).catch( error => {
    return error
  })
}

export async function checkEmails( emails ) {
  let url = '/api/users/checkmails'
  return await $axios.post( url, {
    'emails': emails,
  } ).then( response => {
    console.log( response.data.emails )
    return response.data.emails
  }).catch( error => {
    return error
  })
}
